
import Vue from 'vue';
import Plyr, { PlyrEvent, StandardEvent } from 'plyr';
import { PlayerComponent, Consent } from './VideoPlayer';
import { VideoType } from './VideoPlayer.enums';
import { PLYR_CONTROLS, PLYR_EVENTS } from './VideoPlayer.config';
import PlayerIcons from '!!raw-loader!plyr/dist/plyr.svg';

/**
 * `VideoPlayer Player` - contains the player itself, the controls and captions for the video using Plyr library
 */
export default (Vue as PlayerComponent).extend({
  name: 'owc-player',
  props: {
    playerData: {
      type: Object,
      required: true,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    hasUserInteracted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      youtubeConsentEnabled: false,
      player: null,
    };
  },
  watch: {
    hasUserInteracted(isUserInteracted) {
      if (isUserInteracted) {
        this.initializePlyr();
      }
    },
  },
  computed: {
    source() {
      return this.playerData?.source;
    },
    internal() {
      return this.playerData?.videoDetails?.type === VideoType.internal;
    },
    subtitlesSource() {
      return this.playerData?.subtitlesSource;
    },
    plyrSvg: function() {
      return PlayerIcons;
    },
  },
  async mounted(): Promise<void> {
    document.addEventListener(
      'usercentrics-consents-loaded',
      event => {
        this.youtubeConsentEnabled = this.getYoutubeConsentValue((event as CustomEvent).detail.consents);
      },
      false,
    );

    document.addEventListener(
      'usercentrics-consents-updated',
      event => {
        const eventYoutubeConsent = this.getYoutubeConsentValue((event as CustomEvent).detail.consents);
        if (this.youtubeConsentEnabled !== eventYoutubeConsent) {
          this.youtubeConsentEnabled = eventYoutubeConsent;
        }
      },
      false,
    );
  },
  methods: {
    initializePlyr() {
      // Unfortunately watching the `source` and initialize the playser as soon
      // as the source is set won't work. This will cause the other implementation
      // to malfunction.
      this.$nextTick(() => {
        this.player = new Plyr(this.$refs.player, {
          youtube: {
            noCookie: !this.youtubeConsentEnabled,
          },
          controls: [
            PLYR_CONTROLS.play,
            PLYR_CONTROLS.progress,
            PLYR_CONTROLS.volume,
            PLYR_CONTROLS.fullscreen,
            PLYR_CONTROLS.captions,
            PLYR_CONTROLS.playLarge,
          ],
          ...this.playerData?.videoPlayerSettings,
        });

        this.player.on(PLYR_EVENTS.ready as StandardEvent, (event: PlyrEvent) => {
          this.$emit('onReady', event.detail.plyr);
        });
      });
    },
    getYoutubeConsentValue(consents: Consent[]) {
      return consents.find(consent => consent.name === 'YouTube Video')?.enabled;
    },
  },
});
